/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';

import template from './email-template-list-page.component.html';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';
import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../../common/controller/signal-admin-resource-list-state';
import {EmailTemplateApiService, EmailTemplateModel} from './email-template-api.service';
import {APP_SHARED} from '../../common/app-shared';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-email-template-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailTemplateListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.email-templates.email-template';
  readonly showTeams = !!inject(LocalUserPermissions).getAllVisPermissions().MANAGE_SYSTEM;
  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'type'},
    ...(this.showTeams ? [{label: 'team', param: '', sortable: false}] : [])
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<EmailTemplateModel>(
    inject(EmailTemplateApiService),
    {listId: 'fullEmailTemplateList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
